import meetingInsightsStore from '../store/store';
import { InsightsDataFetchSource } from 'owa-meeting-insights-types-and-flights';
import { getInsightsMapKey } from '../helpers/getInsightsMapKey';

export default function isFetchMeetingInsightsServicePending(
    meetingId: string,
    dataFetchSource: InsightsDataFetchSource
): boolean {
    // True if there is already a pending service call going on, i.e the meeting id (for scenario) is in the service queue
    return (
        meetingInsightsStore.pendingServiceQueue.indexOf(
            getInsightsMapKey(meetingId, dataFetchSource)
        ) >= 0
    );
}
